import React from "react";
import Navbar from './Nav.js'
import Header from './Header.js'
import Main from './Main.js'
import Footer from './Footer.js'

const Homepage = () => {
    return(
        <>
            <Navbar />
            <Header />
            <Main />
            <Footer />
        </>
    )
}

export default Homepage;